var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpellpower = function SvgSpellpower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1359,
    height: 1631.829,
    viewBox: "-10 0 1359 1631.829"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1018 582h-1l332 194-382 36-83 376-118-272q-58 116-180 353.5T447 1540q-6 14-11.5 23t-17.5 25.5-27.5 27.5-34.5 14q-38 8-81-19-45-25-57-62-17-50 34-124 21-30 169.5-251.5T643 844l-294 29 288-254-154-352 331 196 287-256Zm-581 4q-81 10-145 62-63 49-91 124-22-86-86-145-53-50-125-70 73-10 132-52 72-51 105-133 18 77 74 134 57 59 136 80m731 457q82 1 153-41-50 65-58 147-9 79 24 151-76-44-163-40-73 3-137 40 44-59 55-131 14-86-22-167 69 41 148 41M778 251q-8-46-38-81-28-33-71-48 47-14 80-51 27-31 36-71 7 41 32 73 30 39 77 56-43 12-74 44-32 33-42 78"
  })));
};
export default SvgSpellpower;